import { hetsApi } from "@/apis/interceptor"
import { IUsersByBranchParams, IResponse, IUsersByBranchResponse } from "@/types"

export const usersByBranchService = {
  getUsersByBranch: async (params: IUsersByBranchParams): Promise<IResponse<IUsersByBranchResponse>> => {
    const response = await hetsApi.get<IResponse<IUsersByBranchResponse>>("/v1/hets/users/by-branch", { params })
    return response.data
  },
}
